import { render, staticRenderFns } from "./DiscountInfobox.vue?vue&type=template&id=03408e68&scoped=true"
import script from "./DiscountInfobox.vue?vue&type=script&lang=js"
export * from "./DiscountInfobox.vue?vue&type=script&lang=js"
import style0 from "./DiscountInfobox.vue?vue&type=style&index=0&id=03408e68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03408e68",
  null
  
)

export default component.exports